exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.TicketBatchOperationBar {\r\n  z-index: 9999;\r\n  position: fixed;\r\n  bottom: 0;\r\n  height: 45px;\r\n  width: 100%;\r\n  -webkit-box-shadow: 0 -1px 3px rgba(0,0,0,.15);\r\n          box-shadow: 0 -1px 3px rgba(0,0,0,.15);\r\n  background: #efefefcc;\r\n  padding: 5px 0 5px 45px;\r\n  margin-left: calc(-1vw + 3px);\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2e9c772","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketBatchOperationBar.vue
// module id = 953
// module chunks = 75